import React from "react";

import { PillSelect, SelectOption } from "components/PillSelect";
import { DataTableColumn } from "components/DataTable/types";

import { getPriceFormat } from "shared/functions";

import { IbanInvoicePayment } from "store/features/ibanInvoiceSlice";

import { IbanInvoicePaymentStatusEnum } from "api";

import dayjs from "dayjs";

export const paymentStatusOptions: SelectOption[] = [
  {
    label: "Ініційовано",
    value: IbanInvoicePaymentStatusEnum.Initialized,
    bgColor: "grey300",
    textColor: "grey800",
  },
  {
    label: "Оплачено",
    value: IbanInvoicePaymentStatusEnum.Paid,
    bgColor: "green300",
    textColor: "green800",
  },
];

interface InvoicePaymentsColumnsOptions {
  onStatusChange: (payment: IbanInvoicePayment, status: string) => void;
}

export const getInvoicePaymentsColumns = ({
  onStatusChange,
}: InvoicePaymentsColumnsOptions): DataTableColumn<IbanInvoicePayment>[] => [
  {
    field: "paymentPurpose",
    headerName: "Призначення",
    maxLines: 3,
  },
  {
    field: "paymentInitiatedDateUtc",
    headerName: "Дата",
    width: 180,
    valueFormatter: (value) =>
      dayjs
        .utc(String(value ?? ""))
        .local()
        .format("DD MMM YY, HH:mm"),
  },
  {
    field: "amount",
    headerName: "Сума, грн",
    width: 160,
    align: "right",
    valueFormatter: (value) => `${getPriceFormat(Number(value ?? 0))} ₴`,
  },
  {
    field: "status",
    headerName: "Статус",
    headerTooltip:
      "Статус платежу. Платіж Ініційовано означає, що користувач натиснув на кнопку «Оплатити» або вибрав банківський застосунок.",
    width: 180,
    renderCell: (row) => (
      <PillSelect
        value={row.status}
        onChange={(status) => onStatusChange(row, status)}
        options={paymentStatusOptions}
      />
    ),
  },
];
